export function bindingOptionsFromArray(array: string[]): Record<string, string> {
  return Object.fromEntries(array.map((v) => [v, v]));
}
